import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api, apiErr } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ShieldCheck, Lock, KeyRound } from 'lucide-react';
import { toast } from 'sonner';

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (pw1 !== pw2) { setError('Las contraseñas no coinciden'); return; }
    if (pw1.length < 10) { setError('La contraseña debe tener al menos 10 caracteres'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: pw1, confirm_password: pw2 });
      setDone(true);
      toast.success('Contraseña actualizada');
      setTimeout(() => nav('/', { replace: true }), 1500);
    } catch (e) {
      setError(apiErr(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex justify-center bg-background">
      <div className="w-full max-w-md flex flex-col relative safe-top">
        <div className="px-6 pt-14 pb-8">
          <div className="h-11 w-11 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center">
            <KeyRound className="h-5 w-5 text-primary" strokeWidth={2}/>
          </div>
          <p className="mt-6 text-[10px] uppercase tracking-[0.28em] text-muted-foreground font-semibold">REGIMEN SIMPLIFICADO DE CONFIANZA 626 · MEXICO <span className="text-[#F97316]">{"(BETA)"}</span></p>
          <h1 className="font-display text-4xl font-extrabold tracking-tighter mt-2 leading-[1.05]">
            Nueva<br/>contraseña
          </h1>
          <p className="text-muted-foreground mt-3 text-sm leading-relaxed">
            Ingresa una nueva contraseña para tu cuenta. Al confirmarla se cerrarán todas las sesiones activas.
          </p>
        </div>

        {done ? (
          <div className="px-6 pb-8" data-testid="reset-done">
            <div className="rounded-lg border border-primary/30 bg-primary/10 p-4">
              <p className="font-semibold text-primary flex items-center gap-2"><ShieldCheck className="h-4 w-4"/> Contraseña restablecida</p>
              <p className="text-sm text-muted-foreground mt-1">Serás redirigido al inicio de sesión…</p>
            </div>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="reset-form" className="px-6 pb-8 space-y-5">
            <div className="space-y-2">
              <Label className="text-[11px] font-bold uppercase tracking-[0.2em] text-muted-foreground">Nueva contraseña</Label>
              <Input
                type="password" autoComplete="new-password" required
                value={pw1} onChange={(e) => setPw1(e.target.value)}
                data-testid="reset-pw1"
                className="h-12 rounded-lg text-base"
                placeholder="Mínimo 10 caracteres"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-[11px] font-bold uppercase tracking-[0.2em] text-muted-foreground">Confirmar contraseña</Label>
              <Input
                type="password" autoComplete="new-password" required
                value={pw2} onChange={(e) => setPw2(e.target.value)}
                data-testid="reset-pw2"
                className="h-12 rounded-lg text-base"
              />
            </div>
            {error && (
              <div data-testid="reset-error" className="text-sm rounded-lg border border-destructive/40 bg-destructive/10 text-destructive px-3 py-2">
                {error}
              </div>
            )}
            <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full h-12 rounded-full text-base font-semibold">
              {loading ? 'Guardando…' : 'Restablecer contraseña'}
            </Button>
            <div className="flex items-start gap-2 mt-6 text-xs text-muted-foreground">
              <Lock className="h-3.5 w-3.5 mt-0.5 flex-shrink-0"/>
              <p>Al restablecer, se cerrarán todas las sesiones activas y se registrará el evento en el historial de seguridad.</p>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
